import CookieConsent, { OPTIONS } from "react-cookie-consent";
import { Toaster } from 'sonner';
import Navbar from './components/Navbar';

import Choice from './pages/Choice';
import Login from './pages/Login';
import Logout from './pages/Logout';
import Menu from './pages/Menu';
import DataTransmission from './pages/DataTransmission';
import DeviceRegistrationAssignment from './pages/DeviceRegistrationAssignment';

import './styles/main.css';
import { Route, Routes } from 'react-router-dom';
import PrivateRoutes from './components/PrivateRoutes';
import useAuthCheck from './customHooks/AuthCheck';
import Spinner from "./components/Spinner";


import ManageDatabaseRoutes from './routes/manage_database/ManageDatabaseRoutes';
import ManageCalculationsRoutes from "./routes/manage_calculations/ManageCalculationsRoutes";
import DashboardRoutes from './routes/dashboard/DashboardRoutes';



function App() {
  const {loading} = useAuthCheck();

  if (loading) {
    return <div className="no-data-div"> <Spinner /> </div>
  }

  return (
    <div>
      <Toaster
        richColors
        icons={{ loading: <Spinner size="small" decorative /> }}
        closeButton
        position="top-center"
        reverseOrder = {false}
        toastOptions={{
          className: 'my-toast-style',
          duration: 3500
        }}
      />
      <Navbar />
      <Routes>
        <Route
          element={<PrivateRoutes />}
        >
          <Route
            path='/'
            element={<Menu />}
          />
          <Route
            path='/menu'
            element={<Menu />}
          />
          <Route
            path='/choice'
            element={<Choice />}
          />
          <Route
            path='/dashboard/*'
            element={<DashboardRoutes />}          
          />
          <Route
            path='/manage-database/*'
            element={<ManageDatabaseRoutes />}
          />
          <Route
            path='/manage-calculations/*'
            element={<ManageCalculationsRoutes />}
          />
          <Route
            path='/data-transmission'
            element={<DataTransmission />}
          />
          <Route
            path='/device-registration/:device_registration_id/assign'
            element={<DeviceRegistrationAssignment />}
          />
          <Route
            path='/logout'
            element={<Logout />}
          />
        </Route>
        <Route
          path='/flexp-login'
          element={<Login />}
        />
      </Routes>
      <CookieConsent
        debug={process.env.NODE_ENV === "development"}
        disableStyles={true}
        location={OPTIONS.BOTTOM}
        buttonText="Got it"
        containerClasses="button-background-style"
        buttonClasses="button-cookie-style"
      >
        This website uses only essential cookies necessary for the proper functioning of the site, such as login and session verification.
      </CookieConsent>
    </div>
  );
}

export default App;
